import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ClipLoader } from "react-spinners";
import { useLocation, useNavigate } from 'react-router-dom';

function UpdateTour() {
  const location = useLocation();
  const navigate = useNavigate();

  const [tourId, setTourId] = useState(null);
  const [tourTitle, setTourTitle] = useState('');
  const [tourDescription, setTourDescription] = useState('');
  const [tourRate, setTourRate] = useState('');
  const [dayCount, setDayCount] = useState(0);
  const [inputs, setInputs] = useState([]);
  const [showInputs, setShowInputs] = useState(false);

  // NEW: Route overview state
  const [routeDescription, setRouteDescription] = useState('');
  const [routeImageFile, setRouteImageFile] = useState(null);
  const [routeImagePreview, setRouteImagePreview] = useState(''); // server URL or local preview

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (location.state && location.state.TourId) {
      setTourId(location.state.TourId);
      fetchTourDetails(location.state.TourId);
    }
  }, [location]);

  const fetchTourDetails = async (tourId) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `https://genzserver.mylksystems.com/Tours/getTourbyId`,
        { tourID: tourId }
      );
      const tourData = response.data.data;
      if (!tourData || tourData.length === 0) return;

      const firstItem = tourData[0];

      // Title / cover / rate
      setTourTitle(firstItem.Title || '');
      // ⚠ adjust if your API returns a different field for cover description
      setTourDescription(firstItem.CoverDescription ?? firstItem.Description ?? '');
      setTourRate(firstItem.rate ?? '');

      // Route overview
      // ⚠ adjust if your API returns different field names
      const routePhotoName = firstItem.RoutePhoto;
      setRouteImagePreview(
        routePhotoName ? `https://genzserver.mylksystems.com/Assets/Tours/${routePhotoName}` : ''
      );
      setRouteDescription(firstItem.RouteDescription || '');

      // Days
      setDayCount(tourData.length);
      const dayInputs = tourData.map((element) => ({
        description: element.dayDescription || element.Description || '',
        photo: element.Photo
          ? `https://genzserver.mylksystems.com/Assets/Tours/${element.Photo}`
          : null,
        isFromServer: true,
      }));
      setInputs(dayInputs);
      setShowInputs(true);
    } catch (error) {
      console.error('Error fetching tour details:', error);
    } finally {
      setLoading(false);
      setFetching(false);
    }
  };

  const handlePhotoChange = (index, file) => {
    const updated = [...inputs];
    updated[index].photo = file;
    updated[index].isFromServer = false;
    setInputs(updated);
  };

  const handleDescriptionChange = (index, desc) => {
    const updated = [...inputs];
    updated[index].description = desc;
    setInputs(updated);
  };

  // NEW: route image chooser + live preview
  const handleRouteImageChange = (file) => {
    setRouteImageFile(file || null);
    if (file) {
      const url = URL.createObjectURL(file);
      setRouteImagePreview(url);
    } else {
      // if cleared
      setRouteImagePreview('');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('tourID', tourId);
    formData.append('title', tourTitle);
    formData.append('description', tourDescription);
    formData.append('rate', tourRate);
    formData.append('days', dayCount);

    // NEW: route fields (backend expects these exact keys)
    formData.append('route_description', routeDescription || '');
    if (routeImageFile) {
      formData.append('route_image', routeImageFile);
    }

    // Non-file day inputs (keeps existing photos when isFromServer=true)
    const nonFileInputs = inputs.map((input) => ({
      description: input.description,
      isFromServer: input.isFromServer,
      photo: input.photo ? input.photo : null, // may be URL or File (but backend only reads for isFromServer)
    }));
    formData.append('inputs', JSON.stringify(nonFileInputs));

    // Append files for days where a new file was chosen
    inputs.forEach((input, index) => {
      if (input.photo && input.photo instanceof File) {
        formData.append(`day_${index + 1}_photo`, input.photo);
      }
    });

    try {

      
      await axios.post('https://genzserver.mylksystems.com/Tours/updateTour', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert('Tour updated successfully!');
      navigate('/ManageTours');
    } catch (error) {
      console.error('Error updating tour:', error);
      alert('Failed to update the tour. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: '40px 20px',
        fontFamily: 'Segoe UI, sans-serif',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '800px',
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        }}
      >
        {fetching ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
            <ClipLoader color="#007BFF" size={50} />
          </div>
        ) : (
          <form onSubmit={handleFormSubmit}>
            <h2
              style={{
                fontSize: '28px',
                marginBottom: '20px',
                color: '#333',
                textAlign: 'center',
              }}
            >
              Update Tour
            </h2>

            <div
              style={{
                marginBottom: '30px',
                fontSize: '16px',
                color: '#555',
                textAlign: 'center',
                fontStyle: 'italic',
              }}
            >
              Please note that you cannot change the number of days here—only update details.
            </div>

            {/* Tour Title */}
            <div style={{ marginBottom: '30px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}>
                Tour Title:
              </label>
              <textarea
                value={tourTitle}
                onChange={(e) => setTourTitle(e.target.value)}
                rows={3}
                placeholder="Enter a short Title for the tour"
                style={{
                  width: '100%',
                  padding: '12px',
                  fontSize: '15px',
                  borderRadius: '6px',
            
                }}
                required
              />
            </div>

            {/* Tour Description */}
            <div style={{ marginBottom: '30px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}>
                Tour Description:
              </label>
              <textarea
                value={tourDescription}
                onChange={(e) => setTourDescription(e.target.value)}
                rows={3}
                placeholder="Enter a short description for the tour"
                style={{
                  width: '100%',
                  padding: '12px',
                  fontSize: '15px',
                  borderRadius: '6px',
                
                }}
                required
              />
            </div>

            {/* Tour Rate */}
            <div style={{ marginBottom: '30px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}>
                Tour Rate:
              </label>
              <input
                value={tourRate}
                onChange={(e) => setTourRate(e.target.value)}
                placeholder="Enter Tour Rate in LKR"
                style={{
                  width: '100%',
                  padding: '12px',
                  fontSize: '15px',
                  borderRadius: '6px',
               
                }}
                type="number"
                min="0"
                required
              />
            </div>

            {/* === NEW: Route Overview === */}
            <div
              style={{
                marginBottom: '30px',
                padding: '20px',
                border: '1px solid #dee2e6',
                borderRadius: '10px',
                backgroundColor: '#fdfdfd',
              }}
            >
              <h3 style={{ marginBottom: '15px', fontSize: '22px', color: '#343a40' }}>Route Overview</h3>

              {/* Current / New Preview */}
              {routeImagePreview && (
                <div style={{ marginBottom: '10px' }}>
                  <img
                    src={routeImagePreview}
                    alt="Route preview"
                    style={{ maxWidth: '100%', maxHeight: '220px', borderRadius: '8px' }}
                  />
                </div>
              )}

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                  Route Photo:
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleRouteImageChange(e.target.files?.[0] || null)}
                  style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ccc', width: '100%' }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                  Route Description:
                </label>
                <textarea
                  value={routeDescription}
                  onChange={(e) => setRouteDescription(e.target.value)}
                  rows={4}
                  style={{
                    width: '100%',
                    padding: '12px',
                    fontSize: '15px',
                    borderRadius: '6px',
                    
                  
                  }}
                  placeholder="Describe the overall route (start/end, main attractions, highlights)"
                />
              </div>
            </div>
            {/* === /NEW === */}

            {/* Day Inputs */}
            {showInputs &&
              inputs.map((input, index) => (
                <div
                  key={index}
                  style={{
                    marginBottom: '30px',
                    padding: '20px',
                    border: '1px solid #dee2e6',
                    borderRadius: '10px',
                    backgroundColor: '#fdfdfd',
                  }}
                >
                  <h3 style={{ marginBottom: '15px', fontSize: '22px', color: '#343a40' }}>
                    Day {index + 1}
                  </h3>

                  {/* Image Preview */}
                  {input.photo && typeof input.photo === 'string' && (
                    <div style={{ marginBottom: '10px' }}>
                      <img
                        src={input.photo}
                        alt={`Day ${index + 1}`}
                        style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '8px' }}
                      />
                    </div>
                  )}

                  {/* File Input */}
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                      Photo:
                    </label>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handlePhotoChange(index, e.target.files[0])}
                      style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ccc', width: '100%' }}
                    />
                  </div>

                  {/* Description */}
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                      Description:
                    </label>
                    <textarea
                      value={input.description}
                      onChange={(e) => handleDescriptionChange(index, e.target.value)}
                      rows={4}
                      style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '15px',
                        borderRadius: '6px'
                      
                      }}
                      placeholder={`Enter description for Day ${index + 1}`}
                      required
                    />
                  </div>
                </div>
              ))}

            {/* Submit Button */}
            {showInputs && (
              <div style={{ textAlign: 'center' }}>
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    padding: '12px 30px',
                    fontSize: '18px',
                    backgroundColor: '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    opacity: loading ? 0.85 : 1,
                  }}
                >
                  {loading ? <ClipLoader color="#ffffff" size={20} /> : 'Update Tour'}
                </button>
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
}

export default UpdateTour;
